import React from 'react';
import { t, jt } from 'ttag';
import style from './conclusionList.scss';
import { isNil, compareByName } from '../../services/helper';
import Price from '../util/Price';

export default function ConclusionList(props) {
    const { label, item, itemsList, resolvePrice } = props;
    const dedupeKey = 'uid';

    // Entfernt Duplikate anhand eines gegebenen Keys und arbeitet IMMER mit einem Plain-Array
    const uniqueBy = (arr, key) => {
        const seen = new Set();
        const plain = Array.from(arr || []); // verhindert sort() auf Immutable
        return plain.filter(obj => {
            const val = obj && obj[key];
            if (val == null || seen.has(val)) return false;
            seen.add(val);
            return true;
        });
    };

    const renderSingleItem = () => (
        <tr>
            <td className={style.model}>{item.code ? item.code : ''}</td>
            <td className={style.description}>{item.name ? item.name : ''}</td>
            <td className={style.weight}>{item.weight ? jt`${item.weight} kg` : t`0 kg`}</td>
            <td className={style.price}>
                <Price value={item.total_price ? resolvePrice(item) : 0} />
            </td>
        </tr>
    );

    const renderMultipleItems = () => {
        if (isNil(itemsList)) {
            return null;
        }
        // Duplikate entfernen (Plain-Array), dann sicher sortieren (Plain-Array)
        const list = uniqueBy(itemsList, dedupeKey).sort(compareByName);
        return list.map((data) => (
            <tr key={data.uid}>
                <td className={style.model}>{data.code ? data.code : ''}</td>
                <td className={style.description}>{data.name ? data.name : ''}</td>
                <td className={style.weight}>{data.weight ? jt`${data.weight} kg` : t`0 kg`}</td>
                <td className={style.price}>
                    <Price value={data.total_price ? resolvePrice(data) : 0} />
                </td>
            </tr>
        ));
    };

    return (
        <div className={style.container}>
            <h5>{label}</h5>
            <hr />
            <table>
                <tbody>
                    {isNil(item) ? renderMultipleItems() : renderSingleItem()}
                </tbody>
            </table>
        </div>
    );
}
